const en = {
  "home": "Home", // 单词翻译
  "profile": "Profile", // 单词翻译
  "product": "Product", // 单词翻译
  "select": "Select", // 单词翻译
  "selected": "Selected", // 单词翻译
  "address": "Address", // 单词翻译
  "description": "Description", // 单词翻译
  "lease": "Lease", // 单词翻译
  "leaseTips": "Out for Delivery, Your package Out for Delivery【DR_Dennis Gonzales : 9458674829】For COD please prepare exact amount, Photo proof of delivery is require. Thanks!",
  "buyNow": "Rent Now", // 单词翻译
  "unavailable": "Unavailable", // 单词翻译
  "priceUnit": "Rp", // 金额单位
  "confirm": "Confirm", // 单词翻译
  "cancel": "Cancel", // 单词翻译
  "back": "Back",
  "close": "Close",
  "appName": "Genggo",
  "loading": "Loading...", // 加载中提示 单词翻译
  "logout": "Log out", // 单词翻译
  "loginExpired": "Login failed. Please login again", // 登录过期提示
  "addAddress": "Add Address", // 单词翻译
  "addressList": "Address List", // 单词翻译
  "default": "Default", // 单词翻译
  "language": "Language", // 单词翻译
  "FAQ": "FAQ", // 单词翻译
  "customerService": "Customer Service",
  "customerServicePop": {
    "whatsapp": "whatsapp",
    "copy": "Copy",
    "copySuccess": "Copied"
  },
  "edit": "Edit", // 单词翻译
  "delete": "Delete", // 单词翻译
  "addSuccess": "Added successfully", // 单词翻译
  "saveSuccess": "Saved successfully", // 单词翻译
  "deleteSuccess": "Deleted successfully", // 单词翻译
  "noMore": "No more", // 没有更多数据提示
  "languageSettings": "Language Settings", // 单词翻译
  "systemError": "System error, please try again later", // 系统错误提示
  "withholdingAuth": {
    "title": "Enable automatic payment",
    "subtitle": "Authorize DANA to pay future rental bills.",
    "description": "We will automatically initiate payment on each due date to help you avoid missed payments and late fees.",
    "agreePrefix": "I have read and agree to the ",
    "agreement": "Auto-debit Authorization Agreement",
    "notNow": "Not now",
    "authorize": "Authorize"
  },
  "retry": "Retry",
  "indexPage": {
    "title": "Home", // 首页标题
    "productTitle": "Product", // 首页产品列表标题
    "greeting": "Hello",
    "subtitle": "Getting your dream iPhone is now easier.",
    "bannerAriaLabel": "Featured promotions",
    "bannerLoadFailed": "Failed to load banners",
    "bannerEmptyTitle": "No banners available",
    "bannerEmptyDescription": "Promotions and product updates will appear here.",
    "shortcutsAriaLabel": "Home shortcuts",
    "myProfile": "My Profile",
    "products": "Products",
    "stores": "Stores",
    "faq": "FAQ",
    "featuredProducts": "Featured Products",
    "seeAll": "See all"
  },
  "bottomNav": {
    "ariaLabel": "Main navigation",
    "home": "Home",
    "products": "Products",
    "account": "Account"
  },
  "productCommon": {
    "firstRentalAmount": "First rental amount",
    "pricePending": "Price pending",
    "applyNow": "Apply Now",
    "rented": "rented",
    "noCreditCard": "No credit card",
    "onlineProcess": "Online process",
    "benefitSummary": "Benefit Summary",
    "lightInstallments": "Light installments",
    "deliveryOnlineProcess": "100% Online Process",
    "freeShippingJabodetabek": "Free Shipping for Online Payment"
  },
  "productState": {
    "loading": "Loading…",
    "loadFailed": "Failed to load data",
    "emptyTitle": "No products available",
    "emptyDescription": "Available rental devices will appear here once they are ready.",
    "searchEmptyTitle": "No matching products found",
    "searchEmptyDescription": "Try a different keyword or clear the search."
  },
  "productsPage": {
    "title": "Products",
    "searchPlaceholder": "Search iPhone or model",
    "clearSearch": "Clear search",
    "closeSearch": "Close search",
    "recentSearches": "Recent searches",
    "clearAll": "Clear all",
    "deleteHistory": "Delete search history",
    "recommendedForYou": "Recommended for you",
    "loadMoreError": "Failed to load more products",
    "recommendationLoadError": "Failed to load recommendations"
  },
  "storesPage": {
    "title": "Store List",
    "emptyTitle": "No stores available",
    "emptyDesc": "There are no stores available in this location yet. Please try again later.",
    "statusOpen": "Business as usual",
    "statusUpgrading": "Upgrading & Coming Soon",
    "unnamed": "Genggo Store",
    "loadFailed": "Failed to load stores",
    "retry": "Retry",
    "dialFailed": "Unable to open phone dialer"
  },
  "faqPage": {
    "heroTitle": "Hi! How can we help you?",
    "heroSubtitle": "Find answers to common questions about our device rental service.",
    "searchPlaceholder": "Search for questions…",
    "noResults": "No matching questions found",
    "contactTitle": "Can’t find your answer?",
    "contactDesc": "Our support team is here to help you with any other questions.",
    "contactSupport": "Contact Support",
    "helpfulQuestion": "Was this information helpful?",
    "helpfulYes": "Yes, it was helpful",
    "helpfulNo": "No, I need more help",
    "helpfulYesToast": "Glad we could help."
  },
  "goodsPage": {
    "title": "Product details", // 商品详情页标题
    "shippingAddress": "Shipping Address",
    "addressLoadFailed": "Unable to load your addresses. Please try again.",
  },
  "skuPop": {
    "chooseVariant": "Choose Variant",
    "selection": "Selection",
    "noSelection": "No selection",
    "noSelectAttr": "Please select {attrName}", // 没有选择sku提示
    "noSelect": "Please select sku", // 没有选择sku提示
    "noStock": "No Stock" // 没有库存提示
  },
  "addressPop": {
    "add": "Add New Address",
    "name": "Name",
    "phone": "Phone number",
    "region": "Region",
    "detail": "Address",
    "regionsPlaceholder": "Please select your region", // 区域选择市列提示
    "deleteTitle": "Delete Address",  // 删除地址标题
    "deleteConfirm": "Are you sure to delete this address?", // 删除地址确认
    'regionEmpty': "Please select your region", // 区域选择为空提示
    "phoneEmpty": "Please enter your phone number", // 手机号为空提示
    "detailEmpty": "Please enter your address", // 地址为空提示
    "nameEmpty": "Please enter your name", // 姓名为空提示
    "phoneError": "Please enter a valid Indonesia phone number", // 手机号格式错误提示
    "noSelectAddress": "Please select your address", // 没有选择地址提示
  },
  "contactPop": {
    "title": "Add Contact",
    "listTitle": "Reference Contacts",
    "editTitle": "Edit Contact",
    "subTitle": "Stay safe and secure - add an emergency contact.",
    "selectRequired": "Please select {count} reference contact | Please select {count} reference contacts",
    "contactTitle": "Contact Person {index}",
    "relation": "Relationship",
    "name": "Name",
    "phone": "Phone number",
    "submit": "Save",
    "addNewContact": "Add New Contact",
    "relationEmpty": "Please select contact person relationship",
    "nameEmpty": "Please enter contact persopn name",
    "nameFormat": "Please enter a valid contact name",
    "phoneError": "Please enter a valid Indonesia phone number", // 手机号格式错误提示
    "phoneRepeat": "Contact phone numbers cannot be duplicated.", // 手机号重复
    "selectedCount": "Selected {selected} of {count}",
    "empty": "No saved contacts",
    "addAnother": "Add another contact",
    "maxCount": "You can select up to {count} contacts",
    "deleteTitle": "Delete contact",
    "deleteConfirm": "Are you sure you want to delete this contact?",
  },
  "myPage": {
    "title": "Profile", // 我的页面标题
    "rentalPlan": "Rental Plan", // 我的页面租借计划标题
    "orderList": "Order List", // 我的页面订单列表标题
    "additionalInfo": "My Information",
    "overdue": "Overdue", // 我的页面逾期标题
    "payNow": "Pay Now", // 我的页面自己还款按钮
    "logoutTitle": "Logout", // 我的页面登出标题
    "logoutContent": "Are you sure you want to logout?", // 我的页面登出内容
    "guest": "Guest",
    "loginRequiredTitle": "Login Required",
    "loginRequiredContent": "You need to log in to continue."
  },
  "accountPage": {
    "title": "My Account",
    "avatar": "Avatar",
    "guestUser": "Guest User",
    "verifiedMember": "Verified Member",
    "unverifiedMember": "Unverified Member",
    "memberSince": "Member since {date}",
    "memberSinceEmpty": "Member since —",
    "loginDescription": "You need to log in to continue.",
    "shortcutsAriaLabel": "Account shortcuts",
    "myOrders": "My Orders",
    "myBills": "My Bills",
    "myInformation": "My Information",
    "myInformationDescription": "Manage your personal information",
    "addressesContacts": "Addresses & Contacts",
    "addressesContactsDescription": "Manage your delivery addresses and contacts",
    "paymentMethods": "Payment Methods",
    "paymentMethodsDescription": "Manage your auto-debit accounts",
    "faqDescription": "Find answers to common questions",
    "settings": "Settings",
    "settingsDescription": "Account and app settings",
    "supportDescription": "Get help from our support team",
    "loadFailed": "Failed to load account information"
  },
  "customerSupportFloating": {
    "whatsapp": "WhatsApp",
    "expand": "Open WhatsApp support",
    "collapse": "Collapse WhatsApp support",
    "open": "Chat with WhatsApp support",
    "online": "ONLINE NOW",
    "title": "WhatsApp Support",
    "subtitle": "Tap to chat with Genggo"
  },
  "paymentMethods": {
    "title": "Auto-debit Accounts",
    "description": "Manage the accounts authorized for automatic rental payments.",
    "addTitle": "Add auto-debit account",
    "addDesc": "Authorize a payment account for automatic rental payments.",
    "addAccount": "Add account",
    "loadFailed": "Failed to load auto-debit accounts",
    "authorizedAt": "Authorized {time}",
    "unauthorizedAt": "Unauthorized {time}",
    "cancelAuthorization": "Cancel authorization",
    "reauthorize": "Reauthorize",
    "cancelTitle": "Cancel authorization",
    "cancelDesc": "Are you sure you want to cancel this authorization?",
    "cancelSuccess": "Authorization canceled",
    "status": {
      "active": "Active",
      "pending": "Pending",
      "expired": "Expired",
      "disconnected": "Inactive"
    }
  },
  "addressContacts": {
    "addresses": "Addresses",
    "contacts": "Contacts",
    "addContact": "Add Contact",
    "goAdd": "Add now",
    "emptyAddresses": "No saved addresses",
    "emptyAddressesDesc": "Add a delivery address to make checkout faster.",
    "emptyContacts": "No saved contacts",
    "emptyContactsDesc": "Add reference contacts for your rental orders.",
    "contactUsageNotice": "We may contact them only if we cannot reach you for identity confirmation, delivery, device return, or safety-related matters. We will not disclose your bill, payment, or rental status.",
    "setDefaultAddressTitle": "Set default address",
    "setDefaultAddressConfirm": "Are you sure you want to set this address as default?"
  },
  "accountSettings": {
    "title": "Settings",
    "agreementsPolicies": "Agreements & Policies",
    "noAgreements": "No agreements available",
    "noAgreementContent": "No agreement content available.",
    "userRegistrationAgreement": "User Registration Agreement",
    "privacyPolicy": "Privacy Policy",
    "dataProcessingConsent": "Personal Data Processing Consent",
    "deviceRentalAgreement": "Device Rental Agreement",
    "accountDeleteAgreement": "Account Delete Agreement",
    "aboutUs": "About Us",
    "accountSecurity": "Account & Security",
    "deleteAccount": "Delete Account",
    "loadFailed": "Failed to load settings"
  },
  "aboutUs": {
    "description": "Genggo is a smart device rental platform\nthat provides high-quality devices\nand reliable services to customers\naround the world.\nOur mission is to make technology\nmore accessible and convenient for everyone.",
    "officialWebsite": "Official Website",
    "contactUs": "Contact Us",
    "openFailed": "No app available to open this link"
  },
  "deleteAccount": {
    "title": "Delete Account",
    "confirmTitle": "Do you want to delete your account?",
    "confirmDescription": "This action cannot be undone. Please read the information below carefully.",
    "noteTitle": "Please note",
    "noteOrder": "If you have any ongoing device rental orders, you will not be able to delete your account.",
    "noteData": "After your account is deleted, all your data and information will be permanently removed and cannot be recovered.",
    "smsTitle": "Verify with SMS Code",
    "smsDescription": "We will send a verification code to your registered mobile number.",
    "codePlaceholder": "Enter SMS code",
    "getCode": "Get Code",
    "codeCountdown": "{seconds}s",
    "codeValidTip": "The code will be valid for 5 minutes.",
    "agreementPrefix": "I have read and agree to the ",
    "agreementName": "Account Deletion Agreement",
    "agreementRequired": "Please agree to the Account Deletion Agreement first",
    "submitConfirmTitle": "Delete account?",
    "submitConfirmDescription": "After confirmation, your account will be deleted and you will be signed out. This action cannot be undone.",
    "codeFailed": "Failed to send verification code",
    "successTitle": "Your account has been deleted",
    "successDescription": "Your app account has been deleted. Some order, payment, contract, tax, fraud-prevention, and dispute records may be retained for legally required or legitimate business purposes as described in our Privacy Policy and Account Deletion Policy.",
    "goHome": "Go to Home",
    "failed": "Failed to delete account"
  },
  "orderPage": {
    "orderTitle": "Order Detail",  // 订单详情页面标题
    "confirmTitle": "Order Confirmation",  // 订单确认页面标题
    "reviewRentalPlan": "Review Rental Plan",
    "orderSafeTitle": "Your order is safe and secure",
    "orderSafeSubtitle": "Unsecured parcel • Verified sellers • Buyer protection",
    "agreementTitle": "Agreement",
    "choosePaymentMethod": "Choose Payment Method",
    "amountDueToday": "Amount Due Today",
    "initialPaymentAmount": "Initial Payment Amount",
    "rentalStartDate": "Estimated Rental start date", // 订单详情页面租借开始日期标题
    "returnDate": "Estimated Rental end date", // 订单详情页面租借结束日期标题
    "rentalStartDateDetail": "Rental Start Date",
    "returnDateDetail": "Rental End Date",
    "rentalDateEstimated": "Estimated",
    "total": "Amount Due Today",   // 订单详情页面总价标题
    "deposit": "Security Deposit", // 订单详情页面押金标题
    "refundableParenthetical": "(Refundable)",
    "rentalTerm": "Rental term",
    "amountPaid": "Amount Paid",
    "amountDueBeforePickup": "Amount Due Before Pickup",
    "rent": "Rent", // 订单详情页面每期租金标题
    "periodicRent": {
      "WEEKLY": "Weekly Rent",
      "BI_WEEKLY": "Bi-weekly Rent",
      "MONTHLY": "Monthly Rent"
    },
    "rentCycleUnit": {
      "WEEKLY": "week",
      "BI_WEEKLY": "2 weeks",
      "MONTHLY": "month"
    },
    "initialRent": "Initial Rental Payment", // 订单详情页面首租金标题
    "remainingRent": "Remaining Rental Payments",  // 订单详情页面剩余租金标题
    "repaymentDate": "Rental Frequency",  // 订单详情页面还款日期标题
    "totalRentalPayments": "Total Rental Payments",  // 订单详情页面还款日期标题
    "remainingAmountNoticeTitle": "The remaining amount will be invoiced",
    "remainingAmountNoticeDesc": "You can pay it in the following month or later.",
    "cancelledOrderNoPaymentTitle": "No payment was processed",
    "cancelledOrderNoPaymentDesc": "Since this order has been cancelled, no payment is required.",
    "cancelledOrderNeedHelpTitle": "Need help?",
    "cancelledOrderNeedHelpDesc": "If you have any questions about this cancellation, please contact our customer service team.",
    "rentalPeriodOngoingNoticeTitle": "Rental Period Ongoing",
    "rentalPeriodOngoingNoticeDesc": "Your rental period has started. Please take good care of the device. Contact us if you encounter any issues.",
    "paymentReceivedNoticeTitle": "Thank you! Your payment has been received.",
    "paymentReceivedNoticeDesc": "You will be notified once your order has been shipped.",
    "payments": "payments",
    "contactTitle": "Contact",
    "addReferenceContacts": "Add Reference Contacts",
    "noContacts": "No contacts",
    "amount": "Amount",
    "reasonPrefix": "Reason: ",
    "additionalInfoBannerTitle": "Submit additional information for faster shipping.",
    "additionalInfoBannerDesc": "Providing more documents may help us process and ship your order sooner.",
    "agText":"I have read and agree to the",
    "agLastText":"and",
    "agreementCheckLabel":"I agree to the agreements above",
    "agreementRequired":"Please agree to the Device Rental Agreement first",
    "moreAgreements": "+{count} more",
    "ownershipNoticeTitle":"Ownership Notice",
    "ownershipNotice":"If all rental payments and other payable amounts are fully paid, and there is no outstanding default, the device will become yours at the end of the rental term. No device return is required after ownership transfer.",
    "importantNotesTitle":"Important Notes",
    "importantNotes1":"If you terminate the rental after the device has been delivered and before completing the first three rental payment periods, the security deposit will not be refunded and the device must be returned.",
    "importantNotes2":"Early termination may also require payment of outstanding rent, late payment fees, early termination fees, repair costs, replacement costs, device loss compensation, and other applicable charges.",
    "importantNotes3":" Late payment fee: Rp30,000 per day, starting from the next calendar day after the due date.",
    "createdDate": "Created date",  // 订单详情页面创建日期标题
    "paymenDate": "Payment date",  // 订单详情页面支付日期标题
    "orderNumber": "Order Number", // 订单详情页面订单编号标题
    "closeDate": "Closed date",
    "closeReason": "Cancel reason",
    "paymentTimeoutCancelReason": "Payment timed out and the order was closed automatically",
    "userCancelledCloseReason": "Cancelled by user",
    "cancelledOnFormat": "Cancelled on {time}",
    "orderCancelledDesc": "This order has been cancelled.",
    "checkout": "Confirm & Continue",   // 订单详情页面去结算按钮
    "checkoutHint": "No payment is required now. You’ll choose COD or online payment after ID verification.",
    "payNow": "Pay Now",
    "pendingPaymentTimeLimitDesc": "Please complete the payment within the time limit.",
    "payUrlTitle": "Continue to Payment",
    "payUrlDesc": "Complete the payment on the payment provider's page, then return here to check the result.",
    "goToPay": "Go to Payment",
    "paymentCompletedButton": "I Have Completed Payment",
    "paymentNotCompleted": "Payment has not been completed yet.",
    "orderExpired": "Order Expired",
    "planTips": "Please note: The rental start date is subject to the actual delivery time.", // 订单详情页面租借计划提示
    "rentalStartAdjusted": "The rental start date is adjusted to the actual delivery date.",
    "rentalPlan": "Rental Plan",
    "rentalPeriodPlan": "Rental Period Plan",
    "repayPlanPeriodFormat": "{period}{suffix}",
    "repayPlanDueDate": "Rent Due Date",
    "repayPlanAmount": "Amount",
    "repayPlanAutoChargeTitle": "Please pay the rent before the due date.",
    "repayPlanAutoChargeDesc": "",
    "orderSuccess": "Order successful", // 订单详情页面订单成功提示
    "orderFailed": "Order failed", // 订单详情页面订单失败提示
    "addressTip": "Please select your address", // 订单详情页面请选择地址提示
    "contactTip": "Please enter your contact person", // 订单详情页面请选择联系人提示
    "payStatus": { // 订单详情页面订单状态头部提示
      "waitingPayment": 'Awaiting Payment', // 待付款
      "success": 'Payment successful', // 支付成功
      "closed": 'Payment canceled',  // 支付取消
    },
    "payErrorTip": "Order failed, please try again later", // 订单详情页面订单失败提示
    "checkoutTitle": "Checkout",
    "payMethodTitle": "Payment Method",
    "onlinePaymentTitle": "Online Payment",
    "onlineOptionTitle": "Pay Now (QRIS)",
    "onlineOptionDesc": "Scan the QR code for fast payment",
    "onlinePayQrisTitle": "QRIS Online Payment",
    "onlinePayQrisDesc": "Scan QR for fast payment",
    "onlinePayAggregatedTitle": "Aggregated Online Payment",
    "onlinePayAggregatedDesc": "Choose your preferred method securely",
    "codOptionTitle": "Cash on Delivery (COD)",
    "codOptionDesc": "Pay when the order is received",
    "storeOptionTitle": "Offline Pickup",
    "storeOptionDesc": "Pay at the store when you pick up your device",
    "storePickupOnly": "Only this method supports in-store pickup",
    "pickupStoreTitle": "Choose a pickup store",
    "storeEmpty": "No pickup stores are available",
    "storeLoadFailed": "Failed to load stores",
    "storeRequired": "Please choose a pickup store",
    "checkoutStore": "Confirm Order",
    "storeVerifyPhoneTitle": "Offline Pickup Order Verification",
    "storeVerifyPhoneDesc": "For your security, a verification code is required to continue with the offline pickup order.",
    "storeConfirmOrder": "Confirm Order",
    "offlineSuccessNavTitle": "Order Submitted",
    "offlineSuccessTitle": "Your order has been submitted",
    "offlineSuccessDesc": "We've received your rental application. Please wait for our review. After approval, you can pick up the phone at the selected store.",
    "storeDetailsTitle": "Store Details",
    "offlineSuccessStoreLabel": "Store",
    "storeHours": "Opening Hours",
    "storePhone": "Store Phone",
    "offlineNextTitle": "What happens next",
    "offlineNextReview": "We will review your application. You will receive a notification once it’s approved.",
    "offlineNextPickup": "After approval, please go to the store during operating hours to pick up the phone.",
    "codRecommended": "Recommended",
    "codNotice": "By choosing COD, please prepare exact change when the courier delivers the order.",
    "codShippingFee": "COD Service Fee",
    "dueAfterApproval": "Due after approval",
    "dueOnDelivery": "Due on delivery",
    "amountDueOnApproval": "Amount Due on Approval",
    "codShippingFeePaid": "COD Service Fee Paid",
    "amountDueOnDelivery": "Amount Due on Delivery",
    "awaitingApproval": "Awaiting approval",
    "awaitingApprovalDesc": "Your order is being reviewed. We will notify you once it is approved.",
    "codShippingFeeNoticeTitle": "COD orders require a COD service fee",
    "codShippingFeeNoticeDesc": "This fee is payable after your order is approved. We will ship your order only after payment is successful.",
    "codShippingFeeNoticeRefund": "COD Service Fee is non-refundable for customer-related cancellations or delivery failures.",
    "payCodShippingFee": "Pay COD Service Fee",
    "checkoutOnline": "Confirm & Pay",
    "checkoutCod": "Order with COD",
    "codVerifyPhoneTitle": "Verify Your Phone Number",
    "codVerifyPhoneDesc": "For your security, a verification code is required to continue with COD.",
    "codPhoneLabel": "Phone",
    "codVerificationCode": "Verification Code",
    "codVerificationCodePlaceholder": "Enter 6-digit code",
    "codGetCode": "Get Code",
    "codCodeCountdown": "{seconds}s",
    "codCodeTip": "The verification code will be sent via WhatsApp (WA) or SMS.",
    "codConfirmOrder": "Confirm Order",
    "codPhoneMissing": "Phone number is unavailable, please log in again",
    "codCodeSent": "Verification code sent",
    "codCodeSendFailed": "Failed to send verification code",
    "codCodeRequired": "Please enter the 6-digit verification code",
    "codSuccessTitle": "Order Submitted Successfully",
    "codSuccessDesc": "Your Cash on Delivery order has been confirmed. Please prepare payment when the device is delivered.",
    "codSuccessCardTitle": "Cash on Delivery",
    "codSuccessCardDesc": "Please prepare Rp{amount} when the device is delivered. The courier will collect payment before handing over the device.",
    "codSuccessShippingFeeNoticeDesc": "After the order is approved, please pay the COD Service Fee online. The order will be shipped immediately after the payment is successful.",
    "codDeliveryReminderBefore": "Please prepare",
    "codDeliveryReminderAfter": "when the device is delivered. The device will be handed over after payment is completed.",
    "dueOnApproval": "Due on approval",
    "backToHome": "Back to Home",
    "viewOrder": "View Order",
    "codLabel": "COD",
    "codAmountTitle": "Amount to Pay on Delivery",
    "codPaymentReminder": "COD Payment Reminder",
    "codPaymentReminderIntro": "You chose Cash on Delivery (COD).",
    "codPaymentReminderDesc": "Please prepare Rp{amount} when the device is delivered. The device will be handed over after payment.",
    "codReminder": "Please prepare Rp{amount} when the device is delivered.",
    "pay": "Pay",
    "payAtStore": "Pay before pickup",
    "storePaymentReminder": "Offline Pickup Reminder",
    "storePaymentReminderDesc": "Please go to the selected store and pay the amount due on delivery. After the payment is completed, you can pick up the device at the store.",
    "storePickupReminderTitle": "Pickup Reminder",
    "storePickupReminderDesc": "Your first rental payment and security deposit have been paid successfully. Please visit the selected store as soon as possible to pick up your phone.",
    "paymentDateCod": "Payment date (COD)",
    "cancelOrder": "Cancel Order",
    "statusPaymentCompleted": "Payment Completed",
    "statusAwaitingShipment": "Awaiting Shipment",
    "statusAwaitingDelivery": "Awaiting Delivery",
    "viewLogisticsProgress": "View Logistics Progress",
    "statusDelivered": "Delivered",
    "statusInRental": "In Rental",
    "awaitingShipmentDesc": "Your order is confirmed and waiting for shipment.",
    "approvedAwaitingShipmentDesc": "Your order has been approved and is being prepared for shipment. Tracking information will be available once shipped.",
    "awaitingDeliveryDesc": "Your order is on the way. Please confirm receipt when you receive the package.",
    "orderedOnFormat": "Ordered on {time}",
    "paidOnFormat": "Paid on {time}",
    "deliveredOnFormat": "Delivered on {time}",
    "deliveredDescription": "Your device has been delivered. Your rental period has started.",
    "refundedNotice": "The payment will be refunded within 5 business days.",
    "importantNotes": "Important Notes",
    "belanjaAmanTitle": "Rent safely and conveniently",
    "belanjaAmanDesc": "Your payment is protected; pay when the device arrives.",
    "codShippingFeeCheckoutSafeTitle": "Transaction secure & encrypted",
    "codShippingFeeCheckoutTitle": "COD Service Fee",
    "onlineBelanjaAmanDesc": "Your payment is protected; pay when the device arrives.",
    "transaksiAman": "Secure & encrypted transaction",
    "rincianPesanan": "Order Details",
    "lihatRincian": "View Details",
    "totalPembayaran": "Total Payment",
    "securityDeposit": "Security Deposit",
    "initialRentalPayment": "First Rental Amount",
    "firstRentalPayment": "First Rental Payment",
    "firstRentalAmount": "First rental amount",
    "firstMonthRentSecurityDeposit": "First rental amount + security deposit",
    "remainingRentalPayments": "{count} payments * {price}",
    "rentalFrequency": "Rental Frequency",
    "totalRentalPaymentsCheckout": "Total Rental Payments",
    "returningTitle": "Returning",
    "returnInProgress": "Return in Progress",
    "returningDescription": "Please return the device by the end date. We will inspect it after we receive it.",
    "returnCompletedTitle": "Return Completed",
    "returnCompletedDescription": "Thank you! We've received and inspected the device. This order is now complete.",
    "orderSuccessCompletedDescription": "Payment completed. Your rental has ended. Thank you for your order!",
    "deliveryAddress": "Delivery Address",
    "referenceContacts": "Reference Contacts",
    "contactsAdded": "{count} contact added | {count} contacts added",
    "product": "Product",
    "rentalDates": "Rental Dates",
    "pricePlan": "Price Plan",
    "copyOrderNumber": "Copy order number",
    "copySuccess": "Order number copied",
    "copyFailed": "Copy failed",
    "backToOrders": "Back to Orders",
    "whatsapp": "WhatsApp",
    "paid": "Paid",
  },
  "orderList": {
    "title": "Order List", // 订单列表页面标题
    "myOrders": "My Orders",
    "orderNo": "Order No. {id}",
    "copySuccess": "Order number copied",
    "filters": { "all": "All", "active": "Active", "breaching": "Terminating", "completed": "Completed", "closed": "Closed" },
    "deposit": "Deposit", // 订单列表页面押金标题
    "preInstallment": "Per Installment", // 订单列表页面分期标题
    "empty": "No orders yet", // 订单列表页面没有订单提示
    "emptyDesc": "Your rental orders will appear here once you place one.",
    "shopNow": "Shop now",
    "cancelSuccess": "Order canceled", // 取消订单成功提示
    "cancelFailed": "Order cancel failed", // 取消订单失败提示
    "cancelTitle": "Cancel Order", // 订单列表页面取消订单标题
    "cancelContent": "Are you sure you want to cancel this order?",
    "cancelRefundDesc": "Please confirm your cancellation. After approval, this order will be closed and the eligible amount will be refunded to the account you provide.",
    "cancelBackTrackDesc": "Please confirm your cancellation. After approval, the eligible amount will be refunded to the original payment method.",
    "cancelCodDesc": "Are you sure you want to cancel this order? This action cannot be undone after submission.",
    "orderAmount": "Order Amount",
    "cancelRefundAmount": "Refund Amount",
    "cancelReason": "Cancellation Reason", // 取消理由
    "cancelReasonPlaceholder": "Please describe the reason for cancellation", // 退款理由占位
    "keepOrder": "Keep Order",
    "codCancelNoticeTitle": "Cash on Delivery (COD) Order",
    "codCancelNoticeDesc": "You have not made any payment yet. No refund will be issued for this cancellation.",
    "refundAccount": "Refund Account",
    "refundAccountNotice": "The refund will be sent to this account within 3-5 business days after the cancellation is confirmed.",
    "refundType": "Refund Method",
    "refundTypeEmpty": "Please select a refund method",
    "bankCard": "Bank Card",
    "virtualAccount": "Virtual Account",
    "eWallet": "E-Wallet",
    "bankName": "Bank Name",
    "selectBankPlaceholder": "Please select a bank",
    "selectVAPlaceholder": "Please select a virtual account",
    "selectEWalletPlaceholder": "Please select an e-wallet",
    "bankEmpty": "Please select a bank",
    "accountNo": "Account Number",
    "accountNoPlaceholder": "Please enter your account number",
    "accountNoEmpty": "Please enter your account number",
    "accountName": "Account Holder Name",
    "accountNamePlaceholder": "Please enter the account holder name",
    "accountNameEmpty": "Please enter the account holder name",
    "accountNoError": "Invalid account number format",
    "accountNameError": "Account name contains invalid characters",
    "logistics": {
      "deliveryProgress": "Delivery Progress:",
      "paymentCompleted": "Payment Completed, Awaiting Shipment",
      "shipped": "Shipped, Awaiting Delivery",
      "delivered": "Delivered (Signed)",
      "preparingShipment": "Your payment has been received. The item is being prepared for shipment.",
      "logistics": "Your item has been shipped and is on the way.",
      "awaitingShipment": "Awaiting shipment",
      "awaitingReceipt": "Awaiting receipt",
      "signed": "Delivered"
    },
    "cancelStatus": {
      "titlePending": "Cancellation Requested",
      "titleApproved": "Refunded",
      "titleRejected": "Cancellation Rejected",
      "subtitleUnderReview": "Under Review",
      "descReviewing": "We are reviewing your cancellation request.",
      "descRefunded": "The payment will be refunded within 5 business days.",
      "appliedOnFormat": "Applied on {time}",
      "approvedOnFormat": "Approved on {time}",
      "rejectedOnFormat": "Rejected on {time}",
      "rejectReasonFormat": "Reject Reason: {reason}",
      "contactService": "If you have any questions, please contact customer service.",
      "withdrawRequest": "Withdraw Request",
      "withdrawTitle": "Withdraw this request?",
      "withdrawContent": "Are you sure you want to withdraw your cancellation request?",
      "withdrawSuccess": "Cancellation request withdrawn"
    },
    "paymentDeadline": {
      "prefix": "Complete to payment before ",
      "suffix": "to avoid automatic cancellation."
    },
    "status": {
      "waitingPay": 'Awaiting Payment', // 待支付
      "underLease": 'In Rental', // 租赁中
      "completed": 'Completed', // 已完成
      "closed": 'Cancelled', // 已关闭
      "breach": 'Completed', // 已退租
      "breaching": 'Return in Process', // 退租中
    },
    "options": {
      "cancel": "Cancel", // 取消
      "orderDetail": "Order Detail", // 订单列表页面订单详情按钮
      "rentalPlan": "Rental Plan", // 订单列表页面租借计划按钮
      "deliveryProgress": "Delivery Progress", // 订单列表页面订单物流信息按钮
      "payNow": "Go to Pay",
      "terminalDetail": "Terminal Detail"
    }
  },

  "express": {
    "title": "Express", // 物流信息标题
    "courier": "Courier", // 快递公司名称
    "trackingNumber": "Tracking number", // 物流信息物流单号标题
    "emptyTips": "No tracking information available yet."
  },
  "login": {
    "title": "Genggo", // 登录页面标题
    "registerTips": "If you're not registered, we'll automatically create an account and log you in.",  // 登录页面注册提示
    "welcome_message": "Rent now,\n own it later.", // 登录页面欢迎语
    "invalid_phone": "Please enter a valid Indonesia phone number",  // 登录页面手机号验证
    "countdown_text": "{seconds}s retry", // 登录页面倒计时提示
    "get_verification_code": "Send Code",  // 登录页面获取验证码按钮
    "phone_placeholder": "phone number 08XX-XXX-XXXX",  // 登录页面手机号输入框提示
    "code_placeholder": "Enter verification code",  // 登录页面验证码输入框提示
    "login_button": "Login",  // 登录页面登录按钮
    "verification_sent": "Verification code sent",  // 登录页面验证码发送成功提示
    "verification_failed": "Failed to send verification code", // 登录页面验证码发送失败提示
    "login_success": "Login successful", // 登录页面登录成功提示
    "login_failed": "Login failed, please check your verification code", // 登录页面登录失败提示
    "agreement_required": "Please agree to the agreements first",
    "code_message": "Please check your WhatsApp or SMS for the verification code.",
    "subtitle_rent_to_own": "Phone rent-to-own made simple",
    "feature_flexible": "Flexible payments",
    "feature_trusted": "Trusted and secure",
    "feature_yours": "Yours to keep"
  },
  "payment": {
    "success": "Payment successful", // 支付成功标题
    "failed": "Payment failed", // 支付失败标题
    "timeout": "Payment timeout", // 支付超时标题
    "successSub": "Payment successful, please wait for the system to process", // 支付成功提示
    "failedSub": "Payment failed, please try again", // 支付失败提示
    "timeoutSub": "Payment timeout, please try again", // 支付超时提示
    "paymentDetails": "Payment Details", // 单词翻译
    "orderNumber": "Order No.", // 单词翻译
    "paymentTime": "Payment Time", // 单词翻译
    "total": "Total",   // 支付结果页总价标题
    "deposit": "Deposit", // 支付结果页押金标题
    "rent": "Rent", // 支付结果页租金标题
    "insurance": 'Insurance', // 支付结果页保险标题
    "penalty": 'Penalty', // 支付结果页违约金标题
    "return_damage": 'payment.return_damage',
    "btnGoHome": "Back to Home", // 支付结果页按钮文案 翻译单词
    "btnReorder": "Reorder", // 支付结果页按钮文案 翻译单词
    "btnOrderList": "Order List" // 支付结果页按钮文案 翻译单词
  },
  "cycle": { // 租借周期
    "WEEKLY": 'Weekly',   // 周
    "BI_WEEKLY": 'Bi-Weekly', // 双周
    "MONTHLY": 'Monthly' // 月
  },
  "rentalplan": {
    "title": "My Bills", // 租赁列表标题
    "orderNumber": "Order No.", // 单词翻译
    "total": "Total", // 单词翻译
    "overdue": "Overdue", // 单词翻译
    "paid": "Paid",
    "unpaid": "Unpaid",
    "dueAmount": "Due Amount",
    "dueDate": "Due Date",
    "unknownProduct": "Unknown product",
    "payNow": "Pay Now", // 还款按钮
    "installment": "Installment", // 单词翻译
    "upcoming": "Pending",
    "copyOrderNumber": "Copy order number",
    "copySuccess": "Order number copied",
    "copyFailed": "Copy failed",
    "empty": "No bill available", // 列表为空提示
    "emptyDesc": "Upcoming rental bills and payment status will appear here.",
    "shopNow": "Shop now",
    "securePaymentNote": "Secure payments powered by trusted partners.",
  },
  "planDetail": { // 租赁详情页面
    "title": "Rental Plan Detail", // 租金详情页面标题
    "billDetails": "Bill Details",
    "copyOrderNumber": "Copy order number",
    "copySuccess": "Order number copied",
    "copyFailed": "Copy failed",
    "orderTime": "Order time",
    "receivedTime": "Received time",
    "billTotalAmount": "Total Amount",
    "billDueDate": "Due Date",
    "totalAmountDue": "Total Amount Due",
    "rentAmount": "Rent Amount",
    "rentAmountThisPeriod": "Rent amount this period",
    "rentalPeriodCount": "Rental period",
    "payRentalBill": "Pay Rental Bill",
    "viewInstallmentPlan": "View Rental Period Plan",
    "viewInstallmentPlanDesc": "Check all rental period schedule & amounts",
    "payOffRemainingRent": "Settle Remaining Rental Fees",
    "payRemainingOptional": "Pay all remaining rental periods early (optional)",
    "securePaymentNote": "Secure payments powered by trusted partners.",
    "payOffSecureNote": "Secure payment and your data are protected.",
    "repayPlanMonthlyTipTitle": "Your rental payments are scheduled monthly.",
    "repayPlanMonthlyTip": "All amounts include applicable taxes.",
    "repayPlanPaymentTipTitle": "Rent bills will be generated on each due date.",
    "repayPlanPaymentTip": "Please pay on time to avoid overdue fees.",
    "repayPlanEmpty": "No repayment plan available",
    "repayPlanLoadFailed": "Failed to load repayment plan",
    "applyForReturn": "Apply for Return",
    "returnDetails": "Return Details",
    "payOffIncludesNote": "This includes all unpaid rent and overdue penalty. No additional penalty will be charged.",
    "remainingPeriods": "Remaining periods",
    "remainingRentalPeriods": "Remaining Rental Periods",
    "remainingRentOnePeriod": "Remaining Rent ({count} Rental Period)",
    "remainingRentManyPeriods": "Remaining Rent ({count} Rental Periods)",
    "payAmountFormat": "Pay {amount}",
    "lateFeeForThisBill": "Late fee for this bill",
    "lateFeeRuleTitle": "Late Fee",
    "lateFeeRuleDesc": "{amount}/day for each overdue rental period.",
    "lateFeeInfo": "Late fees may apply after the due date.",
    "orderNumber": "Order Number", // 单词翻译
    "totalDue": "Total Rental Amount", // 单词翻译"
    "total": "Amount Due", // 单词翻译
    "rent": "Rent", // 单词翻译
    "deposit": 'Deposit', // 单词翻译
    "lateFee": 'Late Fee', // 单词翻译
    "payOff": 'Settle Early', // 单词翻译
    "payNow": 'Pay Now', // 还款页还款按钮
    "selectPrev": 'Please check the installments you wish to repay, in sequential order.', // 按顺序勾选提醒
    "selectOverdue": 'To proceed,please select and repay thepast due installment(s)', // 逾期勾选提醒
    "status": { // 还款页还款计划状态按钮显示
      "due": 'Due', // 待还款
      "unpaid": 'Unpaid',
      "upcoming": 'Pending',
      "paid": 'Paid', // 已还款
      "overdue": 'Overdue', // 逾期
    },
    "terminate": 'Terminate', // 订单列表页面终止按钮
    "paymentRulesTitle": "Payment Rules",
    "paymentRules1": "Please complete each payment on or before the due date.",
    "paymentRules2": "Late payment fee: Rp30,000 per day, starting from the next calendar day after the due date.",
    "paymentRules3": "Late payments may result in payment reminders, account restriction, or temporary restriction of certain non-essential device features, where permitted by law.",
    "paymentRules4": "If all rental payments and other payable amounts are fully paid, and there is no outstanding default, ownership of the device will transfer to you at the end of the rental term.",
    "paymentRules5": "Early termination after delivery and before completing the first three rental payment periods will result in non-refund of the security deposit, and the device must be returned.",
  },
  "terminate": {
    "title": "Terminate Lease", // 终止订单页面标题
    "detailsTitle": "Termination Details",
    "confirmCont": "Are you sure you want to terminate your lease early?", // 终止订单confrim提示
    "tips": "Please note that early termination may incur applicable fees.", // 终止订单费用提示
    "orderInfo": "Order Info",  // 终止订单页面订单信息标题
    "paymentDue": "Payment Due", // 终止订单页面待还款标题
    "penaltyFee": "Early Termination Fee", // 终止订单页面违约金标题
    "penaltyFeeHint": "Tap the question mark above to see how the penalty fee is calculated.",
    "paymentDueRuleTitle": "Payment Due",
    "paymentDueRuleDesc": "15% of remaining rent applies for early termination. Within the first 3 periods, the deposit is forfeited instead.",
    "progress": "Progress", // 终止订单页面进度标题
    "express": "Shipping Information", // 终止订单页面物流信息标题
    "expressNumber": "Tracking number", // 终止订单页面物流单号标题
    "expressCompany": "Tracking Company", // 终止订单页面物流单号标题
    "deposit": "Deposit", //终止订单页面押金标题
    "preInstallment": "Per Installment", // 终止订单页面分期标题
    "btnApply": "Submit Request", // 终止订单页面申请按钮
    "btnConfirm": "Confirm Termination",
    "btnReapply": "Reapply", // 终止订单页面申请按钮
    "btnPay": "Pay Now", // 终止订单页面申请按钮
    "btnExpress": "Submit Shipping Information", // 终止订单页面申请按钮
    "applySuccess": "Apply Success",  // 终止订单页面申请成功标题
    "expressSuccess": "Express Submit Success",  // 终止订单页面申请成功标题
    "expressNumberTip": "Please enter the tracking number", // 终止订单页面物流单号提示
    "expressCompanyTip": "Please select the tracking company", // 终止订单页面物流公司提示
    "returnShippingDesc": "Please provide your return shipping details.",
    "trackingPlaceholder": "Enter tracking number",
    "selectShippingCompany": "Select shipping company",
    "submitConfirmTitle": "Confirm termination request?",
    "submitConfirmDesc": "After submitting, we will review your early termination request. Fees may apply and you may need to return the device.",
    "importantNotes": "Important Notes",
    "paid": "Paid",
    "paidTime": "Paid on {time}",
    "earlyTerminationTitle": "Early Termination Notice",
    "earlyTerminationDesc": "You are applying to terminate your rental early. If approved, you must return the device according to our return instructions.",
    "earlyTerminationDesc2": "Early termination may require payment of outstanding rent, late payment fees, early termination fees, repair costs, replacement costs, device loss compensation, and other applicable charges.",
    "depositNoticeTitle": "Important Deposit Notice",
    "depositNoticeDesc": "If the device has been delivered and you terminate the rental before completing the first three rental payment periods, the security deposit will not be refunded and the device must be returned.",
  },
  "additionalInfo": {
    "status": {
      "not-submitted": "Not Verified",
      "submitted": "Under review",
      "approved": "Verified"
    },
    "title": "Additional Information", // 页面标题
    "submissionResultTitle": "Submission Result", // 页面标题
    "goHome": "Back to Home", // 返回首页按钮
    "submit": "Confirm & Submit", // 提交按钮
    "submitSuccess": "Information submitted successfully", // 提交成功
    "submitFailed": "Submit failed, please try again", // 提交失败
    "requiredDocumentsTip": "Please upload all required documents before submitting",
    "uploadAtLeastOneTip": "Please upload at least one new document",
    "driverLicensePairTip": "Please upload both front and back of the driver’s license",
    "bpjsTkPairTip": "Please upload both front and back of your BPJS TK card",
    "fileTypeTip": "Please upload a file in one of these formats: {formats}",
    "tipBanner": "Please keep your phone available. Our team may contact you if additional information is needed.", // 底部提示
    "terms": {
      "title": "Personal Data Notice", // 条款标题
      "desc1": "To process your rental application, we will collect and use the documents and information you submit, including KTP, Family Card, facial image, bank statement, salary slip, social media information, and other supporting documents.", // 条款描述
      "desc2": "We use this data for identity verification, rental eligibility assessment, fraud prevention, order review, delivery, payment management, overdue management, and legal compliance.",
      "viewFull": "View full terms", // 查看完整条款
      "agreeText": "I have read and agree to the ", // 同意条款文案
      "notAgreedTip": "Please agree to the Personal Data Notice first" // 未同意条款提示
    },
    "upload": {
      "title": "Document Upload", // 文档上传标题
      "uploaded": "Uploaded", // 已上传状态
      "uploadedBankStatement": "Uploaded (Last 3 months)",
      "success": "Uploaded successfully", // 上传成功
      "failed": "Upload failed, please try again", // 上传失败
      "fileTooLarge": "File size exceeds limit. Maximum: {size}MB" // 上传失败
    },
    "docs": {
      "familyCard": "KK (Family Card)", // 家庭卡
      "socialMedia": "Social Media Account Screenshot", // 社交媒体截图
      "bankStatement": "Bank Statement", // 银行账单
      "payslip": "Payslip / Salary Proof", // 工资单
      "driverLicenseFront": "Driver’s License (Front)", // 驾驶证正面,
      "driverLicenseBack": "Driver’s License (Back)", // 驾驶证背面,
      "bpjsTkFront": "BPJS TK (Front)",
      "bpjsTkBack": "BPJS TK (Back)"
    },
    "submissionResult": {
      "title": "Submitted Successfully",
      "desc1": "Your documents have been submitted successfully.",
      "desc2": "We will review your information and notify you once verification is complete."
    }
  },
  "personalAdditionalInfo": {
    "title": "My Information",
    "basicVerification": "Basic Verification",
    "identityVerification": "KTP & Face Recognition",
    "additionalDocuments": "Additional Information",
    "intro": "Please complete your personal information to help us verify your identity and process your rental application faster.",
    "documentsDesc": "Please upload clear and valid documents for your rental application.",
    "documentsTip": "Please upload clear and valid documents. All information will be kept secure and confidential.",
    "underReviewTip": "Your information has been submitted successfully.\nYou do not need to wait for verification results to place an order.",
    "readyTitle": "Almost there!",
    "readyDesc": "Basic verification completed. Please review your information and submit for review.",
    "readyDocumentsTip": "All documents have been uploaded. Please confirm and submit for review.",
    "reviewBeforeSubmit": "You can review or re-upload any document before submitting.",
    "approvedTitle": "All information verified!",
    "approvedDesc": "Thank you! Your information has been verified successfully. You are all set to continue.",
    "rejectedTitle": "Verification Failed",
    "rejectedDesc": "Some information you submitted did not meet our requirements. Please upload again.",
    "rejectedDocumentsTip": "Please check the reason for each rejection and upload again. All documents must be clear, complete and valid.",
    "rejectedDocumentDesc": "Document unclear or incomplete.",
    "reupload": "Re-upload",
    "uploading": "Uploading…",
    "verifying": "Verifying...",
    "verify": "Go certification",
    "upload": "Upload",
    "confirmSubmit": "Confirm & Submit",
    "protectedText": "Your information is protected and will only be used for verification purposes.",
    "notVerified": "Not Verified",
    "loadFailed": "Unable to load information. Please try again.",
    "retry": "Retry",
    "submissionSuccessTitle": "Information submitted successfully",
    "submissionSuccessDesc": "We have received your documents.\nPlease wait while we review your information.",
    "whatNextTitle": "What’s next?",
    "whatNextDesc": "You can now browse and apply for your preferred rental device. We’ll notify you if we need any additional information.",
    "needHelpTitle": "Need help?",
    "needHelpDesc": "Contact our customer support team.",
    "avoidRejectionTitle": "Tips to avoid rejection",
    "avoidRejectionDesc": "• Make sure all documents are original and not edited.\n• Take clear photos in good lighting.\n• Ensure all text and edges are fully visible.",
    "basic": {
      "loading": { "title": "Loading", "desc": "Loading your verification status." },
      "verified": { "title": "Identity verified", "desc": "Your identity has been verified." },
      "unverified": { "title": "Identity verification required", "desc": "Verify your KTP and complete face recognition to confirm your identity." },
      "pending": { "title": "Verification in progress", "desc": "Your identity verification is being processed." },
      "ocr_failed": { "title": "KTP verification failed", "summary": "Your KTP could not be verified.", "desc": "Please re-upload a clear, valid KTP photo.", "bannerDesc": "Your KTP photo did not pass verification. Please upload a clearer KTP photo.", "nextTitle": "KTP photo tips", "nextDesc": "• Use the front side of your KTP.\n• Keep the text, portrait, and four corners visible.\n• Avoid glare, shadows, and blur." },
      "face_failed": { "title": "Face verification failed", "summary": "Your KTP has passed. Face verification was not successful.", "desc": "Please retry face verification and make sure your face is clearly visible.", "bannerDesc": "Your KTP has passed. Please retry face verification to continue.", "nextTitle": "Face verification tips", "nextDesc": "• Keep your face clearly visible.\n• Use good lighting and avoid masks or sunglasses.\n• Follow the face verification prompts on the next page." },
      "error": { "title": "Unable to load", "desc": "Unable to load your verification status. Please try again." }
    },
    "docs": {
      "familyCardDesc": "Upload your Family Card (Kartu Keluarga)",
      "socialMediaDesc": "Upload screenshot of your active social media account (e.g. Instagram, Facebook)",
      "bankStatementDesc": "Upload bank statement for the last 3 months",
      "payslipDesc": "Upload your latest payslip or salary certificate",
      "driverLicenseFrontDesc": "Upload your valid driver’s license",
      "driverLicenseBackDesc": "Upload your valid driver’s license",
      "bpjsTkDesc": "Upload your valid BPJS Ketenagakerjaan",
      "familyCardVerifiedDesc": "Your Family Card has been verified.",
      "socialMediaVerifiedDesc": "Your social media account screenshot has been verified.",
      "bankStatementVerifiedDesc": "Your bank statement (last 3 months) has been verified.",
      "payslipVerifiedDesc": "Your payslip or salary proof has been verified.",
      "driverLicenseVerifiedDesc": "Your driver’s license has been verified.",
      "bpjsTkVerifiedDesc": "Your BPJS Ketenagakerjaan card has been verified."
    }
  },
  "ktpCamera": {
    "title": "KTP document",
    "subtitle": "Scan your KTP",
    "pageDesc": "Take a clear photo or select the front of your KTP from your gallery. You can review it before sending.",
    "frontTitle": "Front of KTP",
    "frontOnly": "Only the front side is required",
    "readyShort": "Ready",
    "notReady": "Not ready",
    "checkAgain": "Needs review",
    "emptyPreview": "No KTP photo selected",
    "gallery": "Gallery",
    "takePhoto": "Take photo",
    "retakePhoto": "Retake photo",
    "beforeSend": "Before you send",
    "checkTextPortrait": "The text and portrait are clear",
    "checkUseKtpFront": "Please use the front side of your KTP, not another photo",
    "checkNoGlare": "There is no glare or reflection",
    "checkCorners": "All four corners are visible",
    "checkCornersVisible": "Move the KTP so all four corners are visible",
    "securityNote": "Your KTP photo is encrypted during upload and is used only for identity verification.",
    "sendVerification": "Send for verification",
    "frontHint": "Take a clear photo of the portrait side of your Indonesian ID card.",
    "cameraPermission": "Camera preview will appear here after permission is granted",
    "openCamera": "Open camera",
    "choosePhoto": "Choose photo",
    "guideTip": "Place the whole card inside the frame. Avoid glare, shadows and fingers.",
    "align": "Align the card inside the frame",
    "keepInsideFrame": "Keep all four corners inside the frame",
    "moveCloser": "Move closer to the KTP",
    "analyzing": "Checking lighting and sharpness...",
    "ready": "Looks good - tap to capture",
    "capture": "Capture",
    "retake": "Retake",
    "confirm": "Upload and continue",
    "qualityPassed": "Photo ready",
    "qualityWarning": "Photo needs a quick check",
    "qualityPassedDesc": "The image has been cropped and compressed for OCR upload.",
    "notKtpPhoto": "We could not find a complete KTP in this photo. Please upload the front side of your KTP.",
    "cornersNotVisible": "The KTP is outside the frame. Please make sure all four corners are visible.",
    "ktpTooSmall": "The KTP is too small in the photo. Please move closer and try again.",
    "tooDark": "The image is too dark. Please take the photo in better lighting.",
    "tooBright": "The image has too much light. Please avoid reflections on the card.",
    "lowQuality": "The photo is not clear enough. Please make sure the KTP text, portrait, and four corners are visible.",
    "autoCrop": "Edge crop",
    "guideCrop": "Guide crop",
    "previewAlt": "Processed KTP preview",
    "cameraUnsupported": "Camera is not supported in this browser.",
    "cameraFailed": "Unable to open the camera. Please check browser permission or choose a photo.",
    "processFailed": "Unable to process this image. Please choose another photo.",
    "invalidDocument": "We could not verify this KTP photo. Please retake or upload a clearer front side of your KTP.",
    "documentServiceUnavailable": "KTP verification is temporarily unavailable. Please try again later.",
    "sessionExpired": "This KTP verification session has expired. Please restart verification.",
    "uploadNetworkFailed": "Unable to upload the KTP photo. Please check your network and try again."
  },
  "kycV2": {
    "enterKtp": "Entering KTP verification...",
    "enterFace": "Entering face verification..."
  },
  "kycPop": {
    "faceVerify": "Face Verification",
    "faceDesc": "To ensure transaction security, we need to verify your identity through facial recognition",
    "faceBullet1": "Takes about 30 seconds",
    "faceBullet2": "One-time verification only",
    "faceBullet3": "Your data is securely protected",
    "faceNote": "NOTE:",
    "faceEnvTip": "Please ensure you are in a well-lit environment and your face is clearly visible",
    "facePrivacy": "I agree to the collection and processing of my biometric data for identity verification purposes in accordance with the ",
    "facePrivacyLink": "\"Privacy Policy\"",
    "faceBtn": "Star Verification",
    "identityVerify": "Identify Verification",
    "identityDesc": "To ensure transaction security, we need to verify your identity",
    "identityBullet1": "Takes about 30 seconds",
    "identityBullet2": "One-time verification only",
    "identityBullet3": "Your data is securely protected",
    "identityStep1": "1: Take a photo of your ID",
    "identityStep2": "2: Complete face verification",
    "identityNote": "NOTE:",
    "identityEnvTip": "Please use this feature in a well-lit environment",
    "identityPrivacy1": "I have read and agree to the ",
    "identityPrivacyLink": "\"Privacy Policy\"",
    "identityPrivacy2": " and ",
    "identityPrivacy3": "Personal Data Processing Consent",
    "identityPrivacy4": " and I agree to proceed with identity verification.",
    "identityBtn": "Start Verification",
    "startVerification": "Star Verification",
    "authResultSuccess": "Verification Success",
    "redirecting": "Redirecting to payment",
    "continueToPayment": "Continue to Payment",
    "authResultRetryDesc": "Please make sure your face is clearly visible and the lighting is sufficient",
    "authResultFailTitle": " failed multiple times. Please try again later",
    "authResultOcrFailDesc1": "The ID information is inconsistent. Please use your own valid ID card.",
    "authResultFailDesc1": "Your current order has been canceled.",
    "authResultFailDesc2": "You can place a new order afterward.",
    "authResultBack": "Back",
    "paymentTitle": "Payment",
    "paymentDesc": "Scan the QR code using your e-wallet",
    "paymentExpiration": "QR code expires in",
    "paymentStep1": "Open your e-wallet(e.g. OVO / DANA)",
    "paymentStep2": "Tap \"Scan\"",
    "paymentStep3": "Scan the QR code to complete payment",
    "saveQR": "Save the QR",
    "paymentExpired": "Payment expired, please try again"
  },
}
export default en;
